
























































import Vue from 'vue'
import { LevelOfEducation } from '@/model/qcq/LevelOfEducation'
import {
  LOAD_JOBS,
  LOAD_EDUCATION,
  LOAD_DETAIL,
  LOAD_SPECIALIZATION,
  LOAD_EDUCATION_ROW,
  LOAD_JOBS_ROW, LOAD_SPECIALIZATION_ROW, LOAD_DETAIL_ROW,
  INSERT_EDUCATION, UPDATE_EDUCATION, DELETE_EDUCATION, INSERT_JOB, UPDATE_JOB, DELETE_JOB,
  INSERT_SPECIALIZATION, UPDATE_SPECIALIZATION, DELETE_SPECIALIZATION,
  INSERT_DETAIL, UPDATE_DETAIL, DELETE_DETAIL
} from '@/store/action-types'
import QcqCommonGrid from '@/components/QcqCommonGrid.vue'
import { Jobs } from '@/model/qcq/Jobs'
import { Specialization } from '@/model/qcq/Specialization'
import { Detail } from '@/model/qcq/Detail'
import { QcqDialogData, QcqDialogRow } from '@/types'
import QcqDialog from '@/components/QcqDialog.vue'
import * as qcqService from '@/services/qcq-service'
import { EducationPayload, JobPayload, SpecializationPayload, DetailPayload } from '@/types/payload'
import { QcqOperations, QcqQualification, SnackbarStateEnum } from '@/types/enums'
import DeleteDialog from '@/components/DeleteDialog.vue'

interface ComponentData {
  masterData: Array<LevelOfEducation>
  dialogData: QcqDialogData
  dialogTitle: string
  openDialog: boolean
  jobsData: Array<Jobs>
  specializationsData: Array<Specialization>
  detailData: Array<Detail>
  isJobsAddEnabled: boolean
  isSpecializationAddEnabled: boolean
  isDetailAddEnabled: boolean
  action: QcqOperations | undefined
  selectedTable: QcqQualification | undefined
  educationId: number | null
  jobId: number | null
  specializationId: number | null
  snackbarState: number
  showSnackbar: boolean
  messageSnackbar: string
  isSaveButtonDisabled: boolean
  isDeleteButtonDisabled: boolean
  showDeleteDialog: boolean
}

export default Vue.extend({
  name: 'QcqQualificationPage',

  data (): ComponentData {
    return {
      masterData: [],
      dialogData: { id: 0, code: '', language: 0, rows: [] },
      dialogTitle: '',
      openDialog: false,
      jobsData: [],
      specializationsData: [],
      detailData: [],
      isJobsAddEnabled: false,
      isSpecializationAddEnabled: false,
      isDetailAddEnabled: false,
      action: undefined,
      selectedTable: undefined,
      educationId: null,
      jobId: null,
      specializationId: null,
      snackbarState: 0,
      showSnackbar: false,
      messageSnackbar: '',
      isSaveButtonDisabled: false,
      isDeleteButtonDisabled: false,
      showDeleteDialog: false
    }
  },

  components: {
    QcqDialog,
    QcqCommonGrid,
    DeleteDialog
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  methods: {
    onCloseDialog (): void {
      this.closeDialog()
    },

    closeDialog (): void {
      this.action = undefined
      this.openDialog = false
      this.showDeleteDialog = false
    },

    enableAddButtons (): void {
      this.isJobsAddEnabled = true
    },

    enableJobsAddButton (): void {
      this.isJobsAddEnabled = true
    },

    enableSpecializationAddButton (): void {
      this.isSpecializationAddEnabled = true
    },

    enableDetailAddButton (): void {
      this.isDetailAddEnabled = true
    },

    onEducationClicked (rowId: number): void { // BildsungradID
      this.enableJobsAddButton()
      this.isSpecializationAddEnabled = false
      this.isDetailAddEnabled = false
      this.educationId = rowId
      this.$store.dispatch(LOAD_JOBS, rowId)
        .then((data: Array<Jobs>) => {
          this.jobsData = data
          this.specializationsData = []
          this.detailData = []
        })
    },

    onEducationDoubleClicked (rowId: number): void {
      this.showDialogEducation(QcqOperations.EDIT, rowId)
    },

    onJobsClicked (rowId: number): void { // BerufeID
      this.enableSpecializationAddButton()
      this.isDetailAddEnabled = false
      this.jobId = rowId
      this.$store.dispatch(LOAD_SPECIALIZATION, rowId)
        .then((data: Array<Specialization>) => {
          this.specializationsData = data
          this.detailData = []
        })
    },

    onJobsDoubleClicked (rowId: number): void {
      this.showDialogJobs(QcqOperations.EDIT, rowId)
    },

    onSpecializationClicked (rowId: number): void { // FachrichtungenID
      this.enableDetailAddButton()
      this.specializationId = rowId
      this.$store.dispatch(LOAD_DETAIL, rowId)
        .then((data: Array<Detail>) => {
          this.detailData = data
        })
    },

    onSpecializationDoubleClicked (rowId: number): void {
      this.showDialogSpecializations(QcqOperations.EDIT, rowId)
    },

    onDetailClicked (): void {
      // do nothing
    },

    onDetailDoubleClicked (rowId: number): void {
      this.showDialogDetails(QcqOperations.EDIT, rowId)
    },

    showDialogDetails (operation: number, currentSelectedRowId: number): void {
      this.$store.dispatch(LOAD_DETAIL_ROW, {
        currentSelectedRowId, operation
      }).then((dialogData: QcqDialogData) => {
        this.dialogTitle = qcqService.createDialogTitleForOperation(operation, this.$t('qcqDialogComponent.addDetails'))
        this.dialogData = dialogData
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.action = operation
        this.selectedTable = QcqQualification.Details
        if (operation === QcqOperations.ADD || operation === QcqOperations.EDIT) {
          this.openDialog = true
        } else if (operation === QcqOperations.REMOVE) {
          this.showDeleteDialog = true
        }
      })
    },

    showDialogSpecializations (operation: number, currentSelectedRowId: number): void {
      this.$store.dispatch(LOAD_SPECIALIZATION_ROW, {
        currentSelectedRowId, operation
      }).then((dialogData: QcqDialogData) => {
        this.dialogTitle = qcqService
          .createDialogTitleForOperation(operation, this.$t('qcqDialogComponent.addSpecializations'))
        this.dialogData = dialogData
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.action = operation
        this.selectedTable = QcqQualification.Specializations
        if (operation === QcqOperations.ADD || operation === QcqOperations.EDIT) {
          this.openDialog = true
        } else if (operation === QcqOperations.REMOVE) {
          this.showDeleteDialog = true
        }
      })
    },

    showDialogJobs (operation: number, currentSelectedRowId: number): void {
      this.$store.dispatch(LOAD_JOBS_ROW, {
        currentSelectedRowId, operation
      }).then((dialogData: QcqDialogData) => {
        this.dialogTitle = qcqService.createDialogTitleForOperation(operation, this.$t('qcqDialogComponent.addJobs'))
        this.dialogData = dialogData
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.action = operation
        this.selectedTable = QcqQualification.Jobs
        if (operation === QcqOperations.ADD || operation === QcqOperations.EDIT) {
          this.openDialog = true
        } else if (operation === QcqOperations.REMOVE) {
          this.showDeleteDialog = true
        }
      })
    },

    showDialogEducation (operation: number, currentSelectedRowId: number): void {
      this.$store.dispatch(LOAD_EDUCATION_ROW, {
        currentSelectedRowId, operation
      }).then((dialogData: QcqDialogData) => {
        this.dialogTitle = qcqService
          .createDialogTitleForOperation(operation, this.$t('qcqDialogComponent.addEducation'))
        this.dialogData = dialogData
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.action = operation
        this.selectedTable = QcqQualification.Education
        if (operation === QcqOperations.ADD || operation === QcqOperations.EDIT) {
          this.openDialog = true
        } else if (operation === QcqOperations.REMOVE) {
          this.showDeleteDialog = true
        }
      })
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      this.onSaveData()
    },

    onSaveData (): void {
      this.isSaveButtonDisabled = true
      if (this.selectedTable === QcqQualification.Education) {
        this.saveEducation()
      } else if (this.selectedTable === QcqQualification.Jobs) {
        this.saveJob()
      } else if (this.selectedTable === QcqQualification.Specializations) {
        this.saveSpecialization()
      } else if (this.selectedTable === QcqQualification.Details) {
        this.saveDetail()
      }
    },

    async saveEducation (): Promise<void> {
      this.isSaveButtonDisabled = true
      this.isDeleteButtonDisabled = true
      const payload: EducationPayload = {
        educationId: '',
        txtCode: this.dialogData.code,
        txtGer: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de')!.description : '',
        txtFra: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr')!.description : '',
        txtIta: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it')!.description : '',
        txtEng: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en')!.description : ''
      }
      if (this.dialogData.id !== null) {
        payload.educationId = this.dialogData.id.toString()
      }
      try {
        if (this.action === QcqOperations.ADD) {
          await this.$store.dispatch(INSERT_EDUCATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.newEducationHasBeenAdded'))
        } else if (this.action === QcqOperations.EDIT) {
          await this.$store.dispatch(UPDATE_EDUCATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedEducationHasBeenEdited'))
        } else if (this.action === QcqOperations.REMOVE) {
          await this.$store.dispatch(DELETE_EDUCATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedEducationHasBeenRemoved'))
        }
        this.closeDialog()
        this.loadEducation()
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
        this.isJobsAddEnabled = false
        this.isSpecializationAddEnabled = false
        this.isDetailAddEnabled = false
        this.jobsData = []
        this.specializationsData = []
        this.detailData = []
      } catch (e) {
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveJob (): Promise<void> {
      this.isSaveButtonDisabled = true
      this.isDeleteButtonDisabled = true
      const payload: JobPayload = {
        educationId: '',
        jobId: '',
        txtCode: this.dialogData.code,
        txtGer: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de')!.description : '',
        txtFra: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr')!.description : '',
        txtIta: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it')!.description : '',
        txtEng: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en')!.description : ''
      }
      if (this.dialogData.id !== null) {
        payload.jobId = this.dialogData.id.toString()
      }
      if (this.educationId !== null) {
        payload.educationId = this.educationId.toString()
      }
      try {
        if (this.action === QcqOperations.ADD) {
          await this.$store.dispatch(INSERT_JOB, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.newJobHasBeenAdded'))
        } else if (this.action === QcqOperations.EDIT) {
          await this.$store.dispatch(UPDATE_JOB, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedJobHasBeenEdited'))
        } else if (this.action === QcqOperations.REMOVE) {
          await this.$store.dispatch(DELETE_JOB, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedJobHasBeenRemoved'))
        }
        this.closeDialog()
        if (this.educationId !== null) {
          this.onEducationClicked(this.educationId)
        }
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      } catch (e) {
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveSpecialization (): Promise<void> {
      this.isSaveButtonDisabled = true
      this.isDeleteButtonDisabled = true
      const payload: SpecializationPayload = {
        specializationId: '',
        jobId: '',
        txtCode: this.dialogData.code,
        txtGer: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de')!.description : '',
        txtFra: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr')!.description : '',
        txtIta: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it')!.description : '',
        txtEng: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en')!.description : ''
      }
      if (this.dialogData.id !== null) {
        payload.specializationId = this.dialogData.id.toString()
      }
      if (this.jobId !== null) {
        payload.jobId = this.jobId.toString()
      }
      try {
        if (this.action === QcqOperations.ADD) {
          await this.$store.dispatch(INSERT_SPECIALIZATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.newSpecializationHasBeenAdded'))
        } else if (this.action === QcqOperations.EDIT) {
          await this.$store.dispatch(UPDATE_SPECIALIZATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedSpecializationHasBeenEdited'))
        } else if (this.action === QcqOperations.REMOVE) {
          await this.$store.dispatch(DELETE_SPECIALIZATION, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedSpecializationHasBeenRemoved'))
        }
        this.closeDialog()
        if (this.jobId !== null) {
          this.onJobsClicked(this.jobId)
        }
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      } catch (e) {
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveDetail (): Promise<void> {
      this.isSaveButtonDisabled = true
      this.isDeleteButtonDisabled = true
      const payload: DetailPayload = {
        specializationId: '',
        detailId: '',
        txtCode: this.dialogData.code,
        txtGer: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'de')!.description : '',
        txtFra: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'fr')!.description : '',
        txtIta: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'it')!.description : '',
        txtEng: this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en') ? this.dialogData.rows.find((item: QcqDialogRow) => item.language === 'en')!.description : ''
      }
      if (this.dialogData.id !== null) {
        payload.detailId = this.dialogData.id.toString()
      }
      if (this.specializationId !== null) {
        payload.specializationId = this.specializationId.toString()
      }
      try {
        if (this.action === QcqOperations.ADD) {
          await this.$store.dispatch(INSERT_DETAIL, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.newDetailHasBeenAdded'))
        } else if (this.action === QcqOperations.EDIT) {
          await this.$store.dispatch(UPDATE_DETAIL, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedDetailHasBeenEdited'))
        } else if (this.action === QcqOperations.REMOVE) {
          await this.$store.dispatch(DELETE_DETAIL, payload)
          this.messageSnackbar = qcqService
            .createSnackbarMessageForOperation(this.action, this.$t('qcqQualificationPage.selectedDetailHasBeenRemoved'))
        }
        this.closeDialog()
        if (this.specializationId !== null) {
          this.onSpecializationClicked(this.specializationId)
        }
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      } catch (e) {
        this.isSaveButtonDisabled = false
        this.isDeleteButtonDisabled = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    loadEducation (): void {
      this.$store.dispatch(LOAD_EDUCATION)
        .then((data: Array<LevelOfEducation>) => {
          this.masterData = data
        })
    }

  },

  created () {
    this.loadEducation()
  }
})
